module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.isAccessAllowed('LoopOp_SurveyInstances_ReadAll') && _vm.globals.currentUserRole < 3) ? _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "checks-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body top-button-bar"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.refreshEnabled
    },
    on: {
      "click": function($event) {
        return _vm.getCheckData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0000) + "\n        ")]), _vm._v(" "), (
    _vm.globals.isAccessAllowed('LoopOp_SurveyInstances_Create') &&
    _vm.globals.isAccessAllowed('LoopOp_SurveyInstancesLocations_ReadAll') &&
    (!_vm.feature.isAudiTarget || !_vm.globals.isAgencyUser)) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "check-management-create-button"
    },
    on: {
      "click": function($event) {
        (_vm.selectedChecks = []),
        (_vm.selectedCheckIds = []),
        (_vm.showAddChecksDialog = true)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0001) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed('LoopOp_SurveyInstancesProperties_Update') &&
    _vm.globals.isAccessAllowed('LoopOp_SurveyInstancesProperties_Create') &&
    (!_vm.feature.isAudiTarget || !_vm.globals.isAgencyUser)) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "check-management-edit-button",
      "disabled": _vm.includeChecks ? _vm.selectedCheckIds.length == 0 : _vm.selectedCheckIds.length == _vm.checkCount
    },
    on: {
      "click": function($event) {
        _vm.showEditChecksDialog = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("edit")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0002) + "\n        ")]) : _vm._e(), _vm._v(" "), (
    _vm.feature.isEnabled('settlement') &&
    _vm.globals.isPaymentsReadingAllowed &&
    !_vm.feature.isAudiTarget) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.selectedChecks.length === 0
    },
    on: {
      "click": function($event) {
        _vm.showCheckPaymentModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("attach_money")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0061) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.feature.isAudiTarget && _vm.globals.isLeadAgencyUser) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "check-management-assign-agency-button",
      "disabled": _vm.selectedChecks.length < 1
    },
    on: {
      "click": function($event) {
        _vm.showCheckLocalAgencyAssignmentModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("assignment")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0075) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.feature.isAudiTarget && _vm.globals.isLeadAgencyUser) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "id": "check-management-copy-check-button",
      "disabled": _vm.selectedChecks.length < 1
    },
    on: {
      "click": function($event) {
        return _vm.cloneSelectedChecks()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("content_copy")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0076) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SurveyInstancesExport_Create')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedClient
    },
    on: {
      "click": function($event) {
        _vm.showExportModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("get_app")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0004) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.globals.isAgencyUser) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.selectedChecks.length < 1 || _vm.globals.isAgencyUser
    },
    on: {
      "click": function($event) {
        return _vm.showAutovalidationDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("assignment_turned_in")]), _vm._v(" "), _c('br'), _vm._v("Autovalidate\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_Read')) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar top-btn-primary",
    attrs: {
      "disabled": _vm.selectedCheckIds.length < 1
    },
    on: {
      "click": function($event) {
        return _vm.openChecks()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("zoom_in")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0005) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.globals.isAudiUser) ? _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": _vm.selectedCheckIds.length != 1
    },
    on: {
      "click": function($event) {
        return _vm.showCheckHistory()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("history")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.CM0080) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 nopadding"
  }, [_c('div', {
    staticClass: "well well-top-bar"
  }, [_c('div', {
    staticClass: "form-group selectbar"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "id": "statusCodeUpdateSelection"
    }
  }, [_c('a', {
    staticClass: "btn btn-default btn-raised",
    attrs: {
      "role": "button",
      "disabled": !_vm.selectedStatusCode ||
        _vm.selectedChecks.length == 0 ||
        !_vm.globals.isAccessAllowed('LoopOp_SurveyInstances_Update')
    },
    on: {
      "click": function($event) {
        return _vm.changeSelectedChecksStatus()
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0006) + ": " + _vm._s(_vm.selectedStatusCode))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-raised dropdown-toggle",
    class: {
      disabled: _vm.allowedStatusCodes.length < 1 || !_vm.globals.isAccessAllowed('LoopOp_SurveyInstances_Update'),
    },
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "disabled": _vm.allowedStatusCodes.length < 1 ||
        !_vm.globals.isAccessAllowed('LoopOp_SurveyInstances_Update')
    }
  }, [_c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, _vm._l((_vm.allowedStatusCodes), function(code, key) {
    return _c('li', {
      key: key
    }, [_c('a', {
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          _vm.selectedStatusCode = code
        }
      }
    }, [_vm._v(_vm._s(_vm.getStatusCodeDescription(code)))])])
  }), 0)]), _vm._v(" "), (
    !_vm.filterStrings.SurveyInstanceStatusId &&
    _vm.globals.isAccessAllowed('LoopOp_SurveyInstances_Update')) ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "statusCodeUpdateSelection",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0046))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn btn-raised",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.togglePageSelected()
      }
    }
  }, [(_vm.isPageSelected() ? !_vm.includeChecks : _vm.includeChecks) ? _c('span', [_vm._v(_vm._s(_vm.lang.CM0007))]) : _c('span', [_vm._v(_vm._s(_vm.lang.CM0008))])]), _vm._v(" "), (
    _vm.feature.isEnabled('settlement') &&
    _vm.globals.isPaymentsReadingAllowed &&
    !_vm.feature.isAudiTarget) ? _c('button', {
    staticClass: "btn btn-raised btn-success",
    on: {
      "click": function($event) {
        _vm.showSettlementDownloadModal = true
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.CM0059) + "\n            ")]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-6",
    staticStyle: {
      "min-height": "50px"
    }
  }, [_c('div', {
    staticClass: "form-group selectbar nopadding"
  }, [(!_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')) ? _c('div', {
    staticClass: "select-filter-container"
  }, [_c('select2', {
    ref: "clientSelect",
    staticClass: "form-control",
    attrs: {
      "id": "check-management-clients-selector",
      "placeholder": _vm.lang.CM0011,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        return _vm.onClientSelection()
      }
    },
    model: {
      value: (_vm.selectedClient),
      callback: function($$v) {
        _vm.selectedClient = $$v
      },
      expression: "selectedClient"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.dataLists.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                " + _vm._s(client.ClientName) + "\n              ")])
  })], 2)], 1) : _c('div', {
    staticClass: "select-filter-container"
  }, [_c('select2', {
    ref: "importerSelect",
    staticClass: "form-control",
    attrs: {
      "id": "check-management-importer-selector",
      "placeholder": _vm.lang.CM0074,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        return _vm.getCheckData()
      }
    },
    model: {
      value: (_vm.selectedImporter),
      callback: function($$v) {
        _vm.selectedImporter = $$v
      },
      expression: "selectedImporter"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.dataLists.importerList), function(importer) {
    return _c('option', {
      key: importer.ImporterGuid,
      domProps: {
        "value": importer.ImporterGuid
      }
    }, [_vm._v("\n                " + _vm._s(importer.ImporterName) + "\n              ")])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "select-filter-container"
  }, [_c('select2', {
    ref: "projectSelect",
    staticClass: "form-control",
    attrs: {
      "id": "check-management-project-selector",
      "disabled": !_vm.selectedClient,
      "placeholder": _vm.lang.CM0048,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        return _vm.onProjectSelection()
      }
    },
    model: {
      value: (_vm.selectedProject),
      callback: function($$v) {
        _vm.selectedProject = $$v
      },
      expression: "selectedProject"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.dataLists.projectsOfClient), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                " + _vm._s(project.ProjectName) + "\n              ")])
  })], 2)], 1), _vm._v(" "), (_vm.globals.currentUserRole < 2 && !_vm.feature.isAudiTarget) ? _c('div', {
    staticClass: "select-filter-container",
    class: {
      'width-15': _vm.selectedCheckType === 'FO'
    }
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.lang.CM0066,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        return _vm.getCheckData()
      }
    },
    model: {
      value: (_vm.selectedCheckType),
      callback: function($$v) {
        _vm.selectedCheckType = $$v
      },
      expression: "selectedCheckType"
    }
  }, [_c('option'), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FO"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0063))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MA"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0064))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AG"
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0065))])])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedCheckType === 'FO') ? _c('div', {
    staticClass: "select-filter-container width-15"
  }, [_c('a', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin": "0 0 2px 0"
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleOnlineStateFilter()
      }
    }
  }, [(_vm.selectedOnlineState === true) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (_vm.selectedOnlineState === false) ? _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]) : _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.CM0067))])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0012))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 1000
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 1000)
      }
    }
  }, [_vm._v("1000")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == 1
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0013))])], 1), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.pageCount > 7 && _vm.selectedPage < _vm.pageCount - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.pageCount || _vm.selectedPage == _vm.pageCount,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(_vm.pageCount, 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0014))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "checksTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.checkCount))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "checksTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0049))])], 1), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-raised",
    staticStyle: {
      "margin-left": "100px"
    },
    attrs: {
      "id": "check-management-custom-settings"
    },
    on: {
      "click": function($event) {
        _vm.showCheckManagementFilterModal = true
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.CM1074) + "\n            ")])])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table",
    staticStyle: {
      "word-wrap": "break-word",
      "table-layout": "fixed"
    },
    attrs: {
      "id": "check-management-main-table"
    }
  }, [_c('thead', [_c('tr', [(_vm.CheckManagementFilter.SID) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyId')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0015) + "\n                "), (_vm.sortField == 'SurveyId' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyId' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.CheckID) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceId')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0016) + "\n                "), (_vm.sortField == 'SurveyInstanceId' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyInstanceId' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.CheckCode) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('ShortSurveyCode')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0017) + "\n                "), (_vm.sortField == 'ShortSurveyCode' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'ShortSurveyCode' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Status) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceStatusId')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0018) + "\n                "), (_vm.sortField == 'SurveyInstanceStatusId' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyInstanceStatusId' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Project) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('ProjectName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0019) + "\n                "), (_vm.sortField == 'ProjectName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'ProjectName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Wave) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('WaveName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0020) + "\n                "), (_vm.sortField == 'WaveName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'WaveName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Scenario) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('ScenarioName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0021) + "\n                "), (_vm.sortField == 'ScenarioName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'ScenarioName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.CheckInfo) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceInfo')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0073) + "\n                "), (_vm.sortField == 'SurveyInstanceInfo' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyInstanceInfo' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.StoreID) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LocationStoreId')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0050) + "\n                "), (_vm.sortField == 'LocationStoreId' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationStoreId' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.LocationName) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LocationName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0051) + "\n                "), (_vm.sortField == 'LocationName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Address) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LocationAddress')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0022) + "\n                "), (_vm.sortField == 'LocationAddress' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationAddress' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Country) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('LocationCountry')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0023) + "\n                "), (_vm.sortField == 'LocationCountry' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'LocationCountry' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Visit) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceAnswerDateOfVisit')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0024) + "\n                "), (_vm.sortField == 'SurveyInstanceAnswerDateOfVisit' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyInstanceAnswerDateOfVisit' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Internalnote) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceNote')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0027) + "\n                "), (_vm.sortField == 'SurveyInstanceNote' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyInstanceNote' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.ExpiryDate) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceUntil')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0028) + "\n                "), (_vm.sortField == 'SurveyInstanceUntil' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyInstanceUntil' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Agency) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceResponsable')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.feature.isAudiTarget ? _vm.lang.CM0065 : _vm.lang.CM0029) + "\n                "), (_vm.sortField == 'SurveyInstanceResponsable' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyInstanceResponsable' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.feature.isAudiTarget && _vm.CheckManagementFilter.Shopper) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('ApprovedShopperName')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0079) + "\n                "), (_vm.sortField == 'ApprovedShopperName' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'ApprovedShopperName' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Score) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "id": "checkMgmtScoreColumnHeader",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceScore')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0030) + "\n                "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")]), _vm._v(" "), (_vm.sortField == 'SurveyInstanceScore' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyInstanceScore' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "checkMgmtScoreColumnHeader",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.CM0052))])], 1) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Progress) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceProgress')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0031) + "\n                "), (_vm.sortField == 'SurveyInstanceProgress' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyInstanceProgress' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.feature.isAudiTarget && _vm.CheckManagementFilter.Progress) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "id": "checkMgmtSettlementColumnHeader",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SettlementStatus')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0060) + "\n                "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")]), _vm._v(" "), (_vm.sortField == 'SettlementStatus' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SettlementStatus' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "checkMgmtSettlementColumnHeader",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0068) + ":\n                "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                + → " + _vm._s(_vm.lang.CM0069) + "\n                "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                o → " + _vm._s(_vm.lang.CM0070) + "\n                "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                x → " + _vm._s(_vm.lang.CM0071) + "\n                "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                - → " + _vm._s(_vm.lang.CM0072) + "\n              ")])], 1) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Modifiedat) ? _c('th', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortCheckData('SurveyInstanceModifiedAt')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.CM0047) + "\n                "), (_vm.sortField == 'SurveyInstanceModifiedAt' && _vm.sortOrder == 'asc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.sortField == 'SurveyInstanceModifiedAt' && _vm.sortOrder == 'desc') ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [(_vm.CheckManagementFilter.SID) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyId),
      expression: "filterStrings.SurveyId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyId", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.CheckID) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceId),
      expression: "filterStrings.SurveyInstanceId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceId", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.CheckCode) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ShortSurveyCode),
      expression: "filterStrings.ShortSurveyCode"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.ShortSurveyCode)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ShortSurveyCode", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Status) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar",
    attrs: {
      "id": "checkMgmtStatusFilterContainer"
    }
  }, [_c('select2', {
    staticClass: "form-control nopadding",
    attrs: {
      "allowClear": true,
      "placeholder": _vm.lang.CM0032
    },
    model: {
      value: (_vm.filterStrings.SurveyInstanceStatusId),
      callback: function($$v) {
        _vm.$set(_vm.filterStrings, "SurveyInstanceStatusId", $$v)
      },
      expression: "filterStrings.SurveyInstanceStatusId"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.dataLists.statusCodes.filter(function (c) { return c.SurveyInstanceStatusId !== 900; })), function(status) {
    return _c('option', {
      key: status.SurveyInstanceStatusId,
      domProps: {
        "value": status.SurveyInstanceStatusId
      }
    }, [_vm._v("\n                    " + _vm._s(status.SurveyInstanceStatusId) + "\n                  ")])
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Project) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  })]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Wave) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.WaveName),
      expression: "filterStrings.WaveName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.WaveName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "WaveName", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Scenario) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ScenarioName),
      expression: "filterStrings.ScenarioName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.ScenarioName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ScenarioName", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.CheckInfo) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceInfo),
      expression: "filterStrings.SurveyInstanceInfo"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceInfo)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceInfo", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.StoreID) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationStoreId),
      expression: "filterStrings.LocationStoreId"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.LocationStoreId)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationStoreId", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.LocationName) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationName),
      expression: "filterStrings.LocationName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.LocationName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationName", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Address) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationAddress),
      expression: "filterStrings.LocationAddress"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.LocationAddress)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationAddress", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Country) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.LocationCountry),
      expression: "filterStrings.LocationCountry"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.LocationCountry)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "LocationCountry", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Visit) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceAnswerDateOfVisit),
      expression: "filterStrings.SurveyInstanceAnswerDateOfVisit"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceAnswerDateOfVisit)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceAnswerDateOfVisit", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Internalnote) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceNote),
      expression: "filterStrings.SurveyInstanceNote"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceNote)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceNote", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.ExpiryDate) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceUntil),
      expression: "filterStrings.SurveyInstanceUntil"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceUntil)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceUntil", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Agency) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceResponsable),
      expression: "filterStrings.SurveyInstanceResponsable"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceResponsable)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceResponsable", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.feature.isAudiTarget && _vm.CheckManagementFilter.Shopper) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.ApprovedShopperName),
      expression: "filterStrings.ApprovedShopperName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.ApprovedShopperName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "ApprovedShopperName", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Score) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceScore),
      expression: "filterStrings.SurveyInstanceScore"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceScore)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceScore", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Progress) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceProgress),
      expression: "filterStrings.SurveyInstanceProgress"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceProgress)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceProgress", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.feature.isAudiTarget && _vm.CheckManagementFilter.Progress) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SettlementStatus),
      expression: "filterStrings.SettlementStatus"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SettlementStatus)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SettlementStatus", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Modifiedat) ? _c('th', {
    staticClass: "nopadding"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterStrings.SurveyInstanceModifiedAt),
      expression: "filterStrings.SurveyInstanceModifiedAt"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.CM0032
    },
    domProps: {
      "value": (_vm.filterStrings.SurveyInstanceModifiedAt)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1), _vm.getCheckData()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filterStrings, "SurveyInstanceModifiedAt", $event.target.value)
      }
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('tbody', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.clearLastSelection),
      expression: "clearLastSelection"
    }],
    staticClass: "main-table-scrollbar"
  }, _vm._l((_vm.checkData), function(check) {
    return _c('tr', {
      key: check.SurveyInstanceId,
      class: {
        info: _vm.isCheckSelected(check.SurveyInstanceGuid) ? _vm.includeChecks : !_vm.includeChecks,
        'text-red': check.SurveyInstanceIsExpired,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectCheck(check.SurveyInstanceGuid, check.SurveyInstanceId, $event)
        },
        "dblclick": function($event) {
          _vm.globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_Read') &&
            !_vm.globals.isAudiUser &&
            _vm.openCheck(check.SurveyInstanceId)
        }
      }
    }, [(_vm.CheckManagementFilter.SID) ? _c('td', [_vm._v("\n              " + _vm._s(check.SurveyId) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.CheckID) ? _c('td', [_vm._v("\n              " + _vm._s(check.SurveyInstanceId) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.CheckCode) ? _c('td', [_vm._v("\n              " + _vm._s(check.ShortSurveyCode) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Status) ? _c('td', [_vm._v("\n              " + _vm._s(check.SurveyInstanceStatusId) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Project) ? _c('td', [_vm._v("\n              " + _vm._s(check.ProjectName) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Wave) ? _c('td', [_vm._v(_vm._s(check.WaveName))]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Scenario) ? _c('td', [_vm._v("\n              " + _vm._s(check.ScenarioName) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.CheckInfo) ? _c('td', [_vm._v("\n              " + _vm._s(check.SurveyInstanceInfo) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.StoreID) ? _c('td', [_vm._v("\n              " + _vm._s(check.LocationStoreId) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.LocationName) ? _c('td', [_vm._v("\n              " + _vm._s(check.LocationName) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Address) ? _c('td', [_vm._v("\n              " + _vm._s(check.LocationAddress) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Country) ? _c('td', [_vm._v("\n              " + _vm._s(check.LocationCountry) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Visit) ? _c('td', [_vm._v("\n              " + _vm._s(check.SurveyInstanceAnswerDateOfVisit) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Internalnote) ? _c('td', {
      attrs: {
        "id": ("tdSurveyInstanceNote" + (check.SurveyInstanceId))
      }
    }, [_vm._v("\n              " + _vm._s(_vm.globals.truncateString(check.SurveyInstanceNote, 30)) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('b-tooltip', {
      attrs: {
        "target": ("tdSurveyInstanceNote" + (check.SurveyInstanceId)),
        "delay": _vm.globals.tooltipDelay,
        "boundary": "viewport"
      }
    }, [_vm._v(_vm._s(check.SurveyInstanceNote))]), _vm._v(" "), (_vm.CheckManagementFilter.ExpiryDate) ? _c('td', [_vm._v("\n              " + _vm._s(check.SurveyInstanceUntil) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Agency) ? _c('td', [_vm._v("\n              " + _vm._s(check.SurveyInstanceResponsable) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.feature.isAudiTarget && _vm.CheckManagementFilter.Shopper) ? _c('td', [_vm._v("\n              " + _vm._s(check.ApprovedShopperName) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Score) ? _c('td', [_vm._v("\n              " + _vm._s(check.SurveyInstanceScore) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Progress) ? _c('td', [_vm._v("\n              " + _vm._s(check.SurveyInstanceProgress) + "\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.feature.isAudiTarget && _vm.CheckManagementFilter.Progress) ? _c('td', [_vm._v("\n              " + _vm._s(check.SettlementStatus) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.CheckManagementFilter.Modifiedat) ? _c('td', [_vm._v("\n              " + _vm._s(check.SurveyInstanceModifiedAt) + "\n            ")]) : _vm._e()], 1)
  }), 0)])])]), _vm._v(" "), _c('CheckManagementAddModal', {
    attrs: {
      "dataLists": _vm.dataLists,
      "selectedClient": _vm.selectedClient,
      "selectedProject": _vm.selectedProject,
      "showDialog": _vm.showAddChecksDialog
    },
    on: {
      "clientSelected": _vm.onClientSelection,
      "dialogClosed": _vm.onAddChecksDialogClosed,
      "dialogDataSaved": _vm.onAddChecksDialogDataSaved,
      "checksCreated": function($event) {
        (_vm.selectedChecks = $event.guids), (_vm.selectedCheckIds = $event.ids)
      }
    }
  }), _vm._v(" "), _c('CheckManagementEditModal', {
    attrs: {
      "dataLists": _vm.dataLists,
      "selectedChecks": _vm.selectedChecks,
      "selectedCheckIds": _vm.selectedCheckIds,
      "selectedClient": _vm.selectedClient,
      "selectedProject": _vm.selectedProject,
      "includeChecks": _vm.includeChecks,
      "showDialog": _vm.showEditChecksDialog,
      "projectSelected": !!_vm.selectedProject
    },
    on: {
      "dialogClosed": _vm.onEditChecksDialogClosed
    }
  }), _vm._v(" "), _c('CheckManagementFilterModal', {
    attrs: {
      "showModal": _vm.showCheckManagementFilterModal
    },
    on: {
      "closeModal": function($event) {
        (_vm.showCheckManagementFilterModal = false), _vm.getCustomSettingsList()
      }
    }
  }), _vm._v(" "), _c('SettlementDownloadModal', {
    attrs: {
      "showModal": _vm.showSettlementDownloadModal
    },
    on: {
      "closeModal": function($event) {
        _vm.showSettlementDownloadModal = false
      }
    }
  }), _vm._v(" "), _c('CheckPaymentModal', {
    attrs: {
      "showModal": _vm.showCheckPaymentModal,
      "surveyInstanceGuids": _vm.selectedChecks
    },
    on: {
      "modalClosed": function($event) {
        (_vm.showCheckPaymentModal = false), _vm.getCheckData()
      }
    }
  }), _vm._v(" "), _c('ShopperFilterModal', {
    attrs: {
      "showModal": _vm.showShopperFilterModal,
      "selectedClient": _vm.selectedClient
    },
    on: {
      "modalClosed": function($event) {
        _vm.showShopperFilterModal = false
      }
    }
  }), _vm._v(" "), (_vm.feature.isAudiTarget && _vm.globals.isLeadAgencyUser) ? _c('CheckLocalAgencyAssignmentModal', {
    attrs: {
      "showModal": _vm.showCheckLocalAgencyAssignmentModal,
      "selectedChecks": _vm.selectedChecks,
      "agencies": _vm.dataLists.agencyList
    },
    on: {
      "modalClosed": function($event) {
        _vm.showCheckLocalAgencyAssignmentModal = false
      },
      "modalDataSaved": function($event) {
        return _vm.getCheckData()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('confirmation-dialog', {
    attrs: {
      "confirmationTitle": _vm.lang.CM0038,
      "yesButtonText": _vm.lang.CM0039,
      "noButtonText": _vm.lang.CM0040,
      "showDialog": _vm.showExportModal
    },
    on: {
      "onYesConfirmation": _vm.downloadCheckData,
      "dialogClosed": function($event) {
        _vm.showExportModal = false
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v("\n        " + _vm._s(_vm.lang.CM0041) + ":\n        "), _c('b', [_vm._v(_vm._s(_vm.getNameOfSelectedClient()))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "autovalidationDialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "text-align": "left"
    }
  }, [(_vm.autovalidation.invalidChecks.length == 0 && _vm.autovalidation.validatedChecks.length == 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("\n              Do you want to autovalidate\n              " + _vm._s(_vm.selectedCheckIds.length) + " checks?\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.CM0036) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.startAutovalidation()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.lang.CM0037) + "\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.autovalidation.invalidChecks.length > 0) ? _c('div', [_c('h3', [_vm._v("Invalid Checks")]), _vm._v(" "), _c('div', {
    staticClass: "autovalidationTable"
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.autovalidation.invalidChecks
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.autovalidation.validatedChecks.length > 0) ? _c('div', [_c('h3', [_vm._v("Validated Checks")]), _vm._v(" "), _c('div', {
    staticClass: "autovalidationTable"
  }, [_c('b-table', {
    staticClass: "autovalidationTable",
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.autovalidation.validatedChecks
    }
  })], 1)]) : _vm._e()])])])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v("Autovalidation")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93aaba56","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckManagement/CheckManagement.vue
// module id = 1709
// module chunks = 1